import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _flagsInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/flags";
import PropTypes from 'prop-types';
import React, { useState, useEffect, useRef } from 'react';
import { Dialog } from '@unite-us/ui';
import { LanguageSelector } from '@unite-us/app-components';
import { RequestOrUploadConsentForm } from './RequestOrUploadConsentForm';
import { CONSENT_OPTIONS } from '../constants';
import '../stylesheets/informedConsent.scss';
export function ConsentDialog(props) {
  var allowSkipConsent = props.allowSkipConsent,
    contact = props.contact,
    employee = props.employee,
    initialConsentType = props.initialConsentType,
    language = props.language,
    flags = _flagsInstanceProperty(props),
    callbacks = props.callbacks,
    adapters = props.adapters,
    constants = props.constants;
  var onNavigateAway = callbacks.onNavigateAway,
    onLanguageChange = callbacks.onLanguageChange;
  var shouldShowTranslationsNewLanguages = flags.shouldShowTranslationsNewLanguages;
  var _useState = useState('initial'),
    _useState2 = _slicedToArray(_useState, 2),
    currentView = _useState2[0],
    setCurrentView = _useState2[1];
  var dialog = useRef(null);
  useEffect(function () {
    // Allows declarative usage of the dialog. To hide the dialog (and drop the internal state)
    // simply do not render this component.
    dialog.current.openDialog();
  }, []);
  var isConsentApp = ['consentApp', 'consentAppAttestation'].includes(currentView);
  var isConsentAppAttestation = currentView === 'consentAppAttestation';
  var Title = isConsentApp && !isConsentAppAttestation ? /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between items-center w-full pr-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pl-2"
  }, "Informed Consent"), /*#__PURE__*/React.createElement(LanguageSelector, {
    onChange: onLanguageChange,
    field: {
      name: CONSENT_OPTIONS.LANGUAGE,
      value: language
    },
    translationsNewLanguageFlag: shouldShowTranslationsNewLanguages
  })) : /*#__PURE__*/React.createElement("div", {
    className: "h-10"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pt-2 pl-2"
  }, "Informed Consent"));
  return /*#__PURE__*/React.createElement(Dialog, {
    id: "consent-dialog",
    ref: dialog,
    title: Title,
    onRequestClose: onNavigateAway,
    size: "jumbo",
    dialogContentStyles: isConsentApp && {
      'overflow-y': 'hidden'
    }
  }, /*#__PURE__*/React.createElement(RequestOrUploadConsentForm, {
    currentView: currentView,
    allowSkipConsent: allowSkipConsent,
    contact: contact,
    employee: employee,
    language: language,
    initialConsentType: initialConsentType,
    callbacks: _objectSpread(_objectSpread({}, callbacks), {}, {
      onCurrentViewChange: function onCurrentViewChange(view) {
        return setCurrentView(view);
      }
    }),
    adapters: adapters,
    constants: constants,
    flags: flags
  }));
}
ConsentDialog.propTypes = {
  allowSkipConsent: PropTypes.bool,
  contact: PropTypes.object.isRequired,
  employee: PropTypes.object.isRequired,
  initialConsentType: PropTypes.string,
  language: PropTypes.string,
  callbacks: PropTypes.shape({
    onNavigateAway: PropTypes.func.isRequired,
    onLanguageChange: PropTypes.func.isRequired,
    onCommunicationSent: PropTypes.func.isRequired,
    onConsentSent: PropTypes.func.isRequired,
    onError: PropTypes.func.isRequired,
    onTrackEvent: PropTypes.func.isRequired
  }).isRequired,
  adapters: PropTypes.shape({
    coreApi: PropTypes.object.isRequired
  }).isRequired,
  constants: PropTypes.shape({
    CONSENT_APP_URL: PropTypes.string.isRequired,
    CONSENT_DOWNLOAD_URL: PropTypes.string,
    VERBAL_CONSENT_SCRIPT_URL: PropTypes.string
  }).isRequired,
  flags: PropTypes.shape({
    shouldShowTranslationsNewLanguages: PropTypes.bool.isRequired
  }).isRequired
};
ConsentDialog.defaultProps = {
  allowSkipConsent: false
};
//# sourceMappingURL=ConsentDialog.js.map